import React, { useState, useEffect } from 'react'

function Consentimientos({ apiCentral }) {
  const [data, setData] = useState([]) // Inicializamos el estado como un arreglo vacío

  useEffect(() => {
    fetch(`${apiCentral}/get/conditions`)
      .then(res => res.json())
      .then(datos => setData(datos))
  }, [apiCentral]) // Aseguramos que solo se ejecute una vez

  return (
    <div className="dashboard-restaurantes-container">
      <h2 className="dashboard-restaurantes-title">Consentimiento</h2>
      <table className="restaurantes-data-table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Email</th>
            <th>Nombre completo</th>
            <th>Aprobo</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((restaurant, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'center' }}>{restaurant.id}</td>
                <td style={{ textAlign: 'center' }}>{restaurant.email}</td>
                <td style={{ textAlign: 'center' }}>{restaurant.nombreCompleto}</td>
                <td style={{ textAlign: 'center' }}>{restaurant.aprobo ? 'Sí' : 'No'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: 'center' }}>
                No hay datos disponibles
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default Consentimientos
